import { render, staticRenderFns } from "./ResponsavelSetor.vue?vue&type=template&id=2a831be8&"
import script from "./ResponsavelSetor.vue?vue&type=script&lang=js&"
export * from "./ResponsavelSetor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports